module.exports = __webpack_public_path__ + "static/media/no_video.22f67251.svg";


//////////////////
// WEBPACK FOOTER
// ./src/statics/images/no_video.svg
// module id = ./src/statics/images/no_video.svg
// module chunks = 0